import { isAlertSessionType } from './apiHelper.js';

const bool = value => value === true || value === 'true';

/**
 * Même règle que RightPanel Android : pendant une alerte, masquer toutes les
 * options ordinaires et ne conserver que les médias actifs et le déclencheur.
 */
export function getSessionControlVisibility(sessionData = {}) {
    const sessionType = String(sessionData.sessionType || '').toUpperCase();
    const isAlert = isAlertSessionType(sessionType);
    const explicitTrigger = String(sessionData.trigger || '').toUpperCase();
    const trigger = isAlert
        ? (explicitTrigger || (sessionType === 'ALERT' || sessionType === 'LIVEMAPALERTE' ? '' : sessionType))
        : '';

    return {
        isAlert,
        trigger,
        travel: !isAlert && Boolean(sessionData.travelMode),
        corridor: isAlert
            ? trigger === 'ITINERARY_OUT_OF_ZONE'
            : bool(sessionData.isCorridorEnabled),
        stop: isAlert
            ? trigger === 'ITINERARY_STOPPED' || trigger === 'LIVE_SHARE_STOPPED'
            : bool(sessionData.isStopDetectionEnabled),
        audio: bool(sessionData.audio),
        video: bool(sessionData.video),
        accident: isAlert
            ? trigger === 'ACCIDENT_DETECTED'
            : bool(sessionData.isAccidentDetectionEnabled),
        shortcut: isAlert
            ? trigger === 'SHORTCUT'
            : bool(sessionData.isShortcutDetectionEnabled),
        application: isAlert && trigger === 'MANUAL',
    };
}
